import { render, staticRenderFns } from "./DatapointsWeek.vue?vue&type=template&id=7633cc6c"
import script from "./DatapointsWeek.vue?vue&type=script&lang=js"
export * from "./DatapointsWeek.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports